export default "__VITE_ASSET__Czw0wVud__"